// extracted by mini-css-extract-plugin
export default {"main":"game_main__8aVaC","shader":"game_shader__V07gA"};